import { URLLike, isURLLike, toHttps, toURL } from '../url';
import { isArray } from '../is';
import { appendInHead } from './_dom';
import { SlugConsole } from '../console';

export interface LoaderURLOptions {
  url: URLLike;
  autoHttps?: boolean;
};

export type LoaderURL = URLLike | LoaderURLOptions;

export interface LoaderBuildOptions {
  type?: string;
  domBuilder: (url: string) => HTMLElement;
}

const loaders: { [url: string]: Promise<void> } = {};
// 动态加载 HTMLElement
export const buildLoader = ({
  domBuilder,
  type = 'script',
}: LoaderBuildOptions) => async function innerLoader(opts: LoaderURL | LoaderURL[]): Promise<void> {
  if (isArray<LoaderURL>(opts)) {
    await Promise.all(opts.map(o => innerLoader(o)));
    return;
  }
  const slugConsole = new SlugConsole();
  const url = (isURLLike(opts)
    ? toHttps(opts)
    : (({ url: s, autoHttps = true }) => (autoHttps ? toHttps(s) : toURL(s)))(opts))
    .toString();
  const label = `[${type}] ${url}`;
  const loader = loaders[label];
  if (loader) {
    slugConsole.log(`wait loading ${label}`);
    return loader;
  }
  slugConsole.log(`start loading ${label}`);
  loaders[label] = new Promise((resolve, reject) => {
    const ele = domBuilder(url);
    appendInHead(ele);
    ele.addEventListener('load', () => resolve(), false);
    ele.addEventListener(
      'error',
      () => {
        delete loaders[label];
        reject();
      },
      false,
    );
  });
  await loaders[label];
};

export const loadScript = (opts: LoaderURL | LoaderURL[]): Promise<void> => buildLoader({
  // type: 'script',
  domBuilder: (url: string) => {
    const ele = document.createElement('script');
    ele.setAttribute('type', 'text/javascript');
    ele.setAttribute('src', url);
    return ele;
  },
})(opts);

export const loadStyle = (opts: LoaderURL | LoaderURL[]): Promise<void> => buildLoader({
  type: 'style',
  domBuilder: (url: string) => {
    const ele = document.createElement('link');
    ele.setAttribute('rel', 'stylesheet');
    ele.setAttribute('href', url);
    ele.setAttribute('type', 'text/css');
    return ele;
  },
})(opts);
